export default {
  "activityList": "Activity list",
  "search": "Search",
  "refresh": "Refresh",
  "add": "Add",
  "activityConfiguration": "Activity configuration",
  "noEventsYet": "No events yet",
  "eventName": "Event name",
  "eventFormat": "Event format",
  "inPerson": "In person",
  "online": "Online",
  "registrationDeadline": "Registration deadline",
  "eventStartsAt": "Event starts at",
  "eventEndsAt": "Event ends at",
  "status": "Status",
  "createdAt": "Created at",
  "sortWeight": "Sort weight",
  "visibility": "Visibility",
  "visible": "Visible",
  "hidden": "Hidden",
  "miniProgramCode": "Mini program code",
  "comingSoon": "Coming soon",
  "actions": "Actions",
  "settings": "Settings",
  "addActivity": "Add activity",
  "backToList": "Back to list",
  "eventCarousel": "Event carousel",
  "carouselImage": "Carousel image",
  "notUploaded": "Not uploaded",
  "delete": "Delete",
  "addImage": "Add image",
  "orPasteAnImageURL": "Or paste an image URL",
  "addURL": "Add URL",
  "recommendedSize686320PxClickAdd": "Recommended size: 686×320 px. Click Add image to upload or × to remove.",
  "contact": "Contact",
  "contactNumber": "Contact number",
  "onlineURL": "Online URL",
  "venueAddress": "Venue address",
  "enterTheVenueAddress": "Enter the venue address",
  "selectDateAndTime": "Select date and time",
  "eventTime": "Event time",
  "to045": "to",
  "start": "Start",
  "end": "End",
  "eventDetails": "Event details",
  "access": "Access",
  "public": "Public",
  "membersOnly": "Members only",
  "publicAnyoneCanViewTheEventDetails": "Public: anyone can view the event details.",
  "membersOnlyOnlyApprovedMembersCanView": "Members only: only approved members can view the event details.",
  "participantLimit": "Participant limit",
  "leaveBlankForNoLimit": "Leave blank for no limit",
  "leaveBlankToAllowUnlimitedParticipants": "Leave blank to allow unlimited participants.",
  "save": "Save",
  "showExpiredActivities": "Show expired activities",
  "show": "Show",
  "hide": "Hide",
  "oK": "OK",
  "all": "All",
  "registrationOpen": "Registration open",
  "inProgress": "In progress",
  "ended": "Ended",
  "eventNameIsRequired": "Event name is required",
  "enterAContactName": "Enter a contact name",
  "enterAContactNumber": "Enter a contact number",
  "selectAnEventFormat": "Select an event format",
  "enterTheVenueAddress070": "Enter the venue address",
  "selectARegistrationDeadline": "Select a registration deadline",
  "selectTheEventStartAndEndTimes": "Select the event start and end times",
  "enterEventDetails": "Enter event details",
  "enterAnImageURLFirst": "Enter an image URL first",
  "uploadFailed": "Upload failed",
  "imageUploaded": "Image uploaded",
  "couldNotLoadData": "Could not load data",
  "couldNotLoadConfiguration": "Could not load configuration",
  "activityConfigurationSaved": "Activity configuration saved",
  "couldNotSaveChanges": "Could not save changes",
  "activityCreated": "Activity created",
  "deleteActivity": "Delete activity “{p0}”?",
  "deleteActivity083": "Delete activity",
  "deleted": "Deleted",
  "couldNotDelete": "Could not delete",
  "activityRefunds": "Activity refunds",
  "noRefundRequests": "No refund requests",
  "orderNumber": "Order number",
  "userNickname": "User nickname",
  "userAvatar": "User avatar",
  "userPhone": "User phone",
  "registrationFee": "Registration fee",
  "refundAmount": "Refund amount",
  "reviewStatus": "Review status",
  "processedAt": "Processed at",
  "approve": "Approve",
  "reject": "Reject",
  "pending": "Pending",
  "approved": "Approved",
  "rejected": "Rejected",
  "approveTheRefundRequestFor": "Approve the refund request for “{p0}”?",
  "approveRefund": "Approve refund",
  "enterARejectionReasonOptional": "Enter a rejection reason (optional)",
  "rejectRequest": "Reject request",
  "cancel": "Cancel",
  "rejectionReason": "Rejection reason",
  "couldNotReviewRefund": "Could not review refund",
  "back": "Back",
  "activityInformation": "Activity information",
  "photoLive": "Photo live",
  "eventRegistration": "Event registration",
  "registrations": "Registrations",
  "eventDetailsPlaceholder": "Enter event details",
  "setUpAFormUnderEventRegistration": "Set up a form under Event registration first.",
  "couldNotLoadActivity": "Could not load activity",
  "activityInformationSaved": "Activity information saved",
  "linkAPhotoLiveAlbumFromThe": "Link a photo live album from the conference system to show its entry on the event page. This is optional. Each association activity can link to one album.",
  "linkPhotoLiveAlbum": "Link photo live album",
  "photoLiveAlbum": "Photo live album",
  "noAlbum": "— No album —",
  "saveLink": "Save link",
  "unlink": "Unlink",
  "currentlyLinked": "Currently linked: {p0}",
  "noPhotoLiveAlbumLinkedOptionallySelect": "No photo live album linked. Optionally select one above.",
  "photoLiveAlbumLinked": "Photo live album linked",
  "photoLiveAlbumUnlinked": "Photo live album unlinked",
  "unlinkThePhotoLiveAlbumFromThis": "Unlink the photo live album from this activity?",
  "couldNotUnlinkAlbum": "Could not unlink album",
  "basicSettings": "Basic settings",
  "registrationForm": "Registration form",
  "selectTheQuestionnaireForThisEventOnly": "Select the questionnaire for this event. Only published questionnaires are listed.",
  "selectARegistrationForm": "Select a registration form",
  "saveSettings": "Save settings",
  "ifNoFormsAreAvailableCreateAnd": "If no forms are available, create and publish a form in Questionnaire management first.",
  "manageQuestionnaires": "Manage questionnaires",
  "advancedSettings": "Advanced settings",
  "allowRepeatedSubmissions": "Allow repeated submissions",
  "whenOffOneSubmissionPerPersonPer": "When off: one submission per person per form.",
  "allowNonMembersToRegister": "Allow non-members to register",
  "whenOnUsersCanRegisterAfterSigning": "When on, users can register after signing in. When off, users must become members first.",
  "registrationSettingsSaved": "Registration settings saved",
  "noMatchingRecords": "No matching records",
  "registeredAt": "Registered at",
  "paidAt": "Paid at",
  "checkInStatus": "Check-in status",
  "view": "View",
  "activity": "Activity:",
  "user": "User:",
  "selectAUser": "Select a user",
  "selectUser": "Select user",
  "nicknameOrPhoneNumber": "Nickname or phone number",
  "reset": "Reset",
  "noUsersAvailable": "No users available",
  "avatar": "Avatar",
  "nickname": "Nickname",
  "phoneNumber": "Phone number",
  "select": "Select",
  "registrationDetails": "Registration details",
  "couldNotLoadUsers": "Could not load users",
  "registrationAdded": "Registration added",
  "couldNotAddRegistration": "Could not add registration",
  "deleteTheRegistrationFor": "Delete the registration for “{p0}”?",
  "deleteRegistration": "Delete registration",
  "recordRange": "Showing {from}–{to} of {total} records",
  "totalRecords": "Total: {total}",
  "activityTitle": "Activity settings · {name}",
  "imageUploadFailed": "Could not upload image",
  "paid": "Paid",
  "refunding": "Refund in progress",
  "refunded": "Refunded",
  "unpaid": "Unpaid",
  "checkedIn": "Checked in",
  "checkInNotRequired": "Not required",
  "notCheckedIn": "Not checked in",
  "activitySettings": "Activity settings"
}
